import TogglerIcon from './TogglerIcon';

export default TogglerIcon;
